<template>
  <div class="container">
    <div v-if="this.section" class="panel">

      <div class="panel-header">
        <div class="input-group">
          <input class="form-input input-sm" type="text" v-model="section.pretty_name">
          <button @click="hidden = !hidden" class="btn btn-sm input-group-btn">
            <i class="icon" :class="{'icon-arrow-down': hidden, 'icon-arrow-up': !hidden}"></i>
          </button>
          <button @click="$emit('delete')" class="btn btn-sm input-group-btn">
            <i class="icon icon-delete"></i>
          </button>
          <button @click="$emit('moveUp')" class="btn btn-sm input-group-btn">
            <i class="icon icon-upward"></i>
          </button>
          <button @click="$emit('moveDown')" class="btn btn-sm input-group-btn">
            <i class="icon icon-downward"></i>
          </button>
        </div>
      </div>

      <div v-show="!hidden" class="panel-body">
        <form class="form-horizontal">

          <div class="form-group">
            <div class="col-3 col-sm-12">
              <label class="form-label">Name in template</label>
            </div>
            <div class="col-9 col-sm-12">
              <input class="form-input input-sm" type="text" v-model="section.name">
            </div>
          </div>

          <div class="form-group">
            <div class="col-3 col-sm-12">
              <label class="form-label">Display by default</label>
            </div>
            <div class="col-9 col-sm-12">
              <label class="form-checkbox">
                <input type="checkbox" v-model="section.display">
                <i class="form-icon"></i>
              </label>
            </div>
          </div>

          <div class="form-group">
            <div class="col-3 col-sm-12">
              <label class="form-label">
                Fields
                
              </label>
            </div>

            <div class="col-9 col-sm-12 innerInput">
              <div class="input-group" v-for="(field, i) in section.fields">
                  <input v-model="field.name" class="form-input input-sm" type="text">
                  <input v-model="field.tag" class="form-input input-sm" type="text">
                  <button @click="removeField(i)" class="btn btn-sm input-group-btn">
                    <i class="icon icon-minus"></i>
                  </button>
              </div>
              <button @click="section.fields.push({name: 'name', tag: '{{tag}}'})" class="btn btn-special">
                  Add <i class="icon icon-plus"></i>
                </button>
            </div>

          </div>
        </form>

        <!-- <templateSection v-for="(s, i) in section.sections"
                         :section="s"
                         v-on:delete="removeSubSec(i)"></templateSection> -->

      </div>

      <!-- <div v-show="!hidden" class="panel-footer"> -->
        <!-- <button @click="addSection" class="btn btn-primary btn-block">Add Subsection</button> -->
      <!-- </div> -->

    </div>

  </div>
</template>

<script>
import templateSection from '@/components/docs/templateSection'
export default {
  name: 'templateSection',
  props: {
    section: Object
  },
  components: {
    templateSection
  },
  data () {
    return {
      hidden: true
    }
  },
  methods: {
    removeField (i) {
      this.section.fields.splice(i, 1)
    }
    // addSection () {
    //   this.section.sections.push({
    //     name: this.section.name + ' > subsection',
    //     fields: [{
    //       name: 'name',
    //       tag: '{{tag}}'
    //     }],
    //     sections: []
    //   })
    // },
    // removeSubSec (i) {
    //   this.section.sections.splice(i, 1)
    // }
  }
}
</script>
<style scoped>
.innerInput input {
  margin: 0 0 5px 0;
}
button.btn.btn-special {
  background: #3661eb;
  border-color: #3661eb;
  color: #fff!important;
  margin: 4px 1em 0 0;
  padding: 1px 12px;
  height: auto;
  border-radius: 10px;
  font-size: .8em;
}
</style>




// WEBPACK FOOTER //
// templateSection.vue?309144ae